const IS_WEB_ASSEMBLY_SUPPORTED = typeof(WebAssembly) !== 'undefined';

export default IS_WEB_ASSEMBLY_SUPPORTED;
